import styled from 'styled-components';

import { transition } from 'ggApp/utils/mixins/transition';
import CategoryMenuButton from 'ggApp/shared/components/CategoryMenu/Button';
import CategoryMenuDesktop from 'ggApp/shared/components/CategoryMenu/Desktop';
import CategoryMenuMobile from 'ggApp/shared/components/CategoryMenu/Mobile';
import CartSummary from 'ggApp/shared/components/CartSummary';

const Wrap = styled.div`
    ${({ theme }) => theme.maxWidth};
    position: relative;
    display: flex;
    width: 100%;
    padding: 12px 80px 0;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding: 16px 16px 0;
    `};

    &:before {
        content: "";
        position: absolute;
        inset: 0;
        opacity: 1;
        background: linear-gradient(
            180deg,
            ${({ theme }) => theme.colors.Background} calc(50% + 8px),
            transparent 50%
        );
        ${transition('opacity', 'medium-desktop', 'standard')};
        ${({ isTransparent }) => isTransparent && `
            opacity: 0;
        `};
    }
`;

const Button = styled(CategoryMenuButton)`
    margin-right: 8px;
    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        cursor: pointer;
        &:hover {
            &:after {
                visibility: visible;
            }
        }
        &:after {
            visibility: hidden;
            content: "";
            display: block;
            position: absolute;
            left: 0px;
            width: 150%;
            height: 24px;
            bottom: -20px;
        }
    `}
`;

const Cart = styled(CartSummary)`
    margin-left: 8px;
`;

const DesktopMenu = styled(CategoryMenuDesktop)`
    top: 72px;
    position: absolute;
    z-index: 1;
`;

const MobileMenu = styled(CategoryMenuMobile)`
    min-height: 100vh;
`;

export {
    Wrap, Button, Cart, DesktopMenu, MobileMenu,
};
